import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SyncCryptService } from './../../core/crypt/sync-crypt.service';
import { environment } from '../../../environments/environment';
import { RecentListResponse } from '../models/recents-list.model';
import { BaseApiInput } from '../models';
@Injectable({
  providedIn: 'root'
})
export class EventReaderService {
  private path = environment.eventreaderhost;
  constructor(
    private http: HttpClient,
    private crypt: SyncCryptService,
  ) { }

  async getHeaderOptions() {
    const params = new BaseApiInput();
    // Call crypt service to get input
    const inputHeaders = await this.crypt.signApiReq(params);

    // Define headers
    const headers = new HttpHeaders()
      .set('X-auth-access-token', inputHeaders.access_token)
      .set('X-auth-signature', inputHeaders.signature)
      .set('X-auth-servtime', inputHeaders.servtime.toString());

    // Create options object with headers
    return {
      headers: headers
    };
  }

  async getRecentsList(input: number): Promise<RecentListResponse> {
    try {
        const params = new BaseApiInput();
        const url = `${this.path}/events/recents`;


      // Call crypt service to get input
      const inputHeaders = await this.crypt.signApiReq(params);

      // Define headers
      const headers = new HttpHeaders()
        .set('X-auth-access-token', inputHeaders.access_token)
        .set('X-auth-signature', inputHeaders.signature)
        .set('X-auth-servtime', inputHeaders.servtime.toString());

      // Create options object with headers
      const options = {
        headers: headers
      };

      // Send POST request with the params data and headers
      const result: RecentListResponse = await this.http.post<RecentListResponse>(url, {userid: input}, options).toPromise();
      return result;
    } catch (error) {
      console.error('Error occurred: while called event reader service', error);
      throw error;
    }
  }

  async getActivityList(options: any): Promise<RecentListResponse> {
    try {
      const url = `${this.path}/activity/list`;
      const headerOptions = await this.getHeaderOptions();

      // Send POST request with the params data and headers
      const result: RecentListResponse = await this.http.post<RecentListResponse>(url, options, headerOptions).toPromise();
      return result;
    } catch (error) {
      console.error('Error occurred: while called event reader service', error);
      throw error;
    }
  }
}
